import { BaseLayout } from "layouts/BaseLayout";
import { NextPage } from "next";
import { DynamicSeo } from "seo";
import { Headline, Section } from "ui";

export const ToolsPage: NextPage = () => {
	return (
		<>
			<BaseLayout>
				<DynamicSeo title={"Tools"} description={"coming soon"} />
				<Section fullWidth={true} fullHeight={true} horizontalAlignment={"center"} verticalAlignment={"center"}>
					<Headline level={1}>Tools coming soon</Headline>
				</Section>
			</BaseLayout>
		</>
	);
};
export default ToolsPage;
